"use client"

import Script from "next/script"
import { useCallback, useEffect, useState, type FunctionComponent } from "react"

type WonderchatScriptProps = {
  userEmail: string
  wonderchatKey: string
}

export const WonderchatScript: FunctionComponent<WonderchatScriptProps> = ({ userEmail, wonderchatKey }) => {
  const [isUserIdentified, setIsUserIdentified] = useState(false)

  const chatbotIdentify = useCallback((): void => {
    if (window.wonderchat && window.chatbotIdentify && userEmail && !isUserIdentified) {
      window.chatbotIdentify({ email: userEmail })
      setIsUserIdentified(true)
    }
  }, [isUserIdentified, userEmail])

  useEffect(() => {
    chatbotIdentify()
  }, [chatbotIdentify, userEmail])

  return (
    <Script
      data-address="app.wonderchat.io"
      data-id={wonderchatKey}
      data-name="wonderchat"
      data-placement="left"
      data-widget-button-size="normal"
      data-widget-size="normal"
      defer
      onLoad={chatbotIdentify}
      src="https://app.wonderchat.io/scripts/wonderchat.js"
    />
  )
}
